
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { Logger } from 'src/app/core/logger';
import { WidgetsContainerComponentAbstract } from 'src/app/abstract/widgets/widgets-container-component.abstract';
import { CdkDrag, CdkDragDrop } from '@angular/cdk/drag-drop';
import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { WidgetsRadioModel } from 'src/app/models/widgets/widgets-radio.model';
import { ValdnWidgetsComparisonModel } from 'src/app/models/widgets-validation/valdn-widgets-comparison.model';
import { ValdnWidgetsDateModel } from 'src/app/models/widgets-validation/valdn-widgets-date.model';
import { ValdnWidgetsIPModel } from 'src/app/models/widgets-validation/valdn-widgets-ip.model';
import { WidgetsMetadataService } from 'src/app/services/widgets/widgets-metadata.service';
import { WidgetsNotifyDeleteService } from 'src/app/services/widgets/widgets-notify-delete.service';
import { ValdnWidgetsTimeRangeModel } from 'src/app/models/widgets-validation/valdn-widgets-time-range.model';
import { WidgetsSelectionService } from 'src/app/services/widgets/widgets-selection.service';

@Component({
  selector: '[appWidgetsRadio]',
  templateUrl: './widgets-radio.component.html',
  styleUrls: ['./widgets-radio.component.scss']
})
export class WidgetsRadioComponent extends WidgetsContainerComponentAbstract implements OnInit {
  @Input() data: WidgetsRadioModel = new WidgetsRadioModel();
  @Input() dropListIds: string[] = [];
  @Output() dropListIdAdded: EventEmitter<string> = new EventEmitter<string>();


  constructor(
    private widgetsService: WidgetsService,
    private selectionService: WidgetsSelectionService,
    private notifyDeleteService: WidgetsNotifyDeleteService,
    private logger: Logger) {
      super();
  }

  ngOnInit(): void {
    // this.data.key = this.widgetsService.getNextKey(this.data.type);
  }

  onWidgetDroppedToCanvas(event: CdkDragDrop<WidgetsAbstract[], WidgetsAbstract[], any>): WidgetsAbstract {
    switch (event.item.data.widgetType) {
      case WidgetsTypeEnum.VALDN_COMP:
        // Pending: return model for specific validation
        return new ValdnWidgetsComparisonModel();
      case WidgetsTypeEnum.VALDN_DATE:
          return new ValdnWidgetsDateModel();
      case WidgetsTypeEnum.VALDN_IP:
        return new ValdnWidgetsIPModel();
      case WidgetsTypeEnum.VALDN_TIMERANGE:
        return new ValdnWidgetsTimeRangeModel();

    }

    return {} as WidgetsAbstract;
  }

  isDroppableWidget(item: CdkDrag<WidgetsAbstract>) {
    switch (item.data.widgetType) {
      case WidgetsTypeEnum.VALDN_COMP:
      case WidgetsTypeEnum.VALDN_DATE:
      case WidgetsTypeEnum.VALDN_IP:
        return true;
    }

    return false;
  }

  onDeleteModal(): void {
    this.notifyDeleteService.notifyDelete(this.data);
  }

  onDebug() {
    // console.log("debug");
  }

  clone(orgWidget: WidgetsRadioModel): WidgetsAbstract {
    const newInput = new WidgetsRadioModel();

    // newInput.type = 'radio';
    // newInput.key = orgWidget.key;
    // newInput.label = orgWidget.label;
    // newInput.description = orgWidget.description;
    // newInput.required = orgWidget.required;
    // newInput.template = orgWidget.template;
    newInput.cloneFrom(orgWidget);
    return newInput;
  }

  onWidgetsReordered(culprits: WidgetsAbstract[]) {
    throw new Error('Method not implemented.');
  }

  onSelect() {
    this.selectionService.toggleSelection(this.data);
  }
}

